// Generated from SVG to Code Figma Plugin

export const ProductLineVideoReference = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21.1626 7.85491C21.1626 6.93711 20.6245 6.10456 19.7878 5.72754L12.9625 2.65234C12.3508 2.37672 11.6501 2.37777 11.0392 2.6552L4.27865 5.72548C3.44528 6.10396 2.91016 6.93471 2.91016 7.84999V16.1456C2.91016 17.0609 3.44526 17.8916 4.27859 18.2701L11.0391 21.3406C11.65 21.618 12.3508 21.6191 12.9626 21.3434L19.7878 18.268C20.6246 17.891 21.1626 17.0585 21.1626 16.1407V7.85491Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.2168 11.75V8.73497C10.2168 8.51943 10.4501 8.38472 10.6368 8.49249L13.2479 10L15.859 11.5075C16.0456 11.6153 16.0456 11.8847 15.859 11.9925L13.2479 13.5L10.6368 15.0075C10.4501 15.1153 10.2168 14.9806 10.2168 14.765V11.75Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.21333"
    />
  </svg>
);
